var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('radio-group',_vm._b({attrs:{"disabled":_vm.disabledTypes},model:{value:(_vm.typeValue),callback:function ($$v) {_vm.typeValue=$$v},expression:"typeValue"}},'radio-group',_vm.attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }